import KIOSK from './pages/kiosk/Container/kiosk';
import Error404 from './pages/ErrorPages/pages-404';
//import Error440 from './pages/ErrorPages/pages-440';
//import PageUnAuthorized from './pages/ErrorPages/pages-unauthorized';

const routes = [

    // { path: '/403', component: PageUnAuthorized, ispublic: true },
    // { path: '/440', component: Error440, ispublic: true },
    
    { path: '/', component: KIOSK, ispublic: true },
    { path: '*', component: Error404, ispublic: true }

];

export default routes;